import request from '../services/request';
import { PATH } from './path';
export const requestIamUserList = async params => {
  return request({
    url: PATH.jdbc.listIamUsers,
    params,
    method: 'get'
  });
};
export const requestSetPwd = async data => {
  return request({
    url: PATH.jdbc.setPwd,
    data,
    method: 'post'
  });
};
export const requestAuth = async data => {
  return request({
    url: PATH.jdbc.auth,
    data,
    method: 'post'
  });
};
